module.exports = __webpack_public_path__ + "img/cambioMensajero64.2c6e4745.png";